import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../base/BaseComponent";
import {base64Encode, letterUUID, uuid} from "../../../../utils";
import changeIcon from "../../../editor/floatTool/change.png";
import warnIcon from "../../../editor/floatTool/warn.png";
import normalIcon from "../../../editor/floatTool/normal.png";
import loadIcon from "../../../editor/floatTool/loading.gif";
import noneIcon from "../../../editor/floatTool/none.png";
import $ from "jquery";
import {Modal} from "antd";
import "./securityCheck.css";

/**
 * creat by tianruojun
 * if(typeof that.securityCheck?.asyncCheck === "function") {
                        that.securityCheck.asyncCheck({contents:{content},call:(res)=>{
                        }})
                    }
 * @description 新媒体通用敏感词检测组件，接收需要检测的内容以及检测模块的身份信息，返回检测结果
 * @class SecurityCheck
 * @extends {BaseComponent}
 */
export const formatItem = (item)=>{
    if(item){
        let type = "";
        switch (item.category) {
            case "SENSITIVE": type = "敏感词"; break;
            case "PERSON_SENSITIVE": type = "敏感人物"; break;
            case "WRONG_CHARACTER": type = "错别字"; break;
            case "PRIVACY_INFORMATION": type = "隐私信息"; break;
            case "OUTSIDE_CHAIN": type = "疑似外链"; break;
            case "MISINFORMATION": type = "误报词库"; break;
        }
        let newWord = '删除';
        if(item.category === 'SENSITIVE') {
            newWord = <span>修改为“<span style={{color: 'rgba(0,0,0,1)'}}>{item.correctWord}</span>”</span>;
        }
        return <span key={uuid()} style={{color: 'rgba(0,0,0,.6)'}}>
            {type}：“<span style={{color:"red"}}>{item.word}</span>”，建议{newWord}
        </span>;
    }
    return "";
};
const CONTENT_SECURITY = `content-security="true"`;
export const removeContentSecurity = (content)=>{
    if(!content)
        return "";
    let $Content = $(`<div>${content}</div>`);
    let maxCount = 10000;
    let currentCount = 0;
    while(true){
        currentCount++;
        let $ContentSecurity = $Content.find(`[${CONTENT_SECURITY}]:eq(0)`);
        if($ContentSecurity.length === 0 || currentCount > maxCount){
            break;
        }
        $ContentSecurity.after($ContentSecurity.html());
        $ContentSecurity.remove();
    }
    return $Content.html();
};
export const addContentSecurityByText = (text) => {
    return `<span class="checkWord" ${CONTENT_SECURITY}">${text}</span>`
};

const checkColor = 'rgba(254, 1, 1, 0.95)'

export const removeColorByInheritCheck = (componentRef) => {
    let body = $(componentRef);
    let checkSpan = body.find(`span[style*="background-color: ${checkColor}"]`).not(`[${CONTENT_SECURITY}]`);
    if (checkSpan.length > 0) {
        console.log('清空继承自敏感词检测的红色背景=====removeColorByInheritCheck')
        checkSpan.each(function () {
            this.style.backgroundColor = "";
        })
    }
    return function(getInnerValue) {
        return getInnerValue&&getInnerValue()
    }
}
export default class SecurityCheck extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            count: this.props.count,
            checkStatus: this.props.checkStatus,
            noInfoCheckRecord: this.props.noInfoCheckRecord || [], // 没有id的检测记录
        }
    }
    setNoInfoCheckRecord = ({contents,data,key}) => {
        if(!key) {
            this.state.noInfoCheckRecord.push({contents,data,key:Date.now()})
        }
    };
    getNoInfoCheckRecord = () => {
        return this.state.noInfoCheckRecord
    };
    componentWillMount() {
    }
    componentDidMount() {
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.state.noInfoCheckRecord = [...this.state.noInfoCheckRecord,...(nextProps.noInfoCheckRecord || [])];
        // 去重
        let newArr = [];
        for(let i=0;i<this.state.noInfoCheckRecord.length;i++) {
            let item = this.state.noInfoCheckRecord[i];
            if(newArr.findIndex(Item=>Item.key===item.key)===-1) {
                newArr.push(item)
            }
        }
        this.state.noInfoCheckRecord = newArr
    }

    /**
     * 异步检测
     * @param {object} contents 检测参数 eg: {contents:"NDQ0NDQ0NDQ0NDQ0",summary: "NDQ0NDQ0NDQ0NDQ0NDQ0NA=="}
     * @param {object} data 检测模块身份 eg: {
     *     check_info_url: "/cm-sites-pms/website/news/getById?webNewsId=63f47d847f440044008dac640",//当前数据查询路径
     *     createStoryMediaName: "国家网络安全宣传1国家网络安全宣传1国家网络安全宣传1国家网络安全宣传",//当前检测媒体名
     *     createStoryUserName: "田编辑123田编辑123田编辑123田编辑123田编辑123",//当前检测的稿件创建人
     *     createStorydeptName: "内容采编",//当前数据创建人部门
     *     createUserName: "田编辑123田编辑123田编辑123田编辑123田编辑123",//当前检测人
     *     id: "63f47d847f440044008dac640",//当前数据id
     * }
     * @param {string} encryptType 检测加密形式,默认 base64 加密
     * @param {string} key 当前检测稿件的id
     * @param {string} formatType 格式化检测结果的类型，默认合并云端和本地检测
     * @param {function} call 检测结果回调
     */
    time = 0;
    asyncCheck = ({contents={},data={},encryptType="base64",key="",formatType="merge",call}) => {
        this.setNoInfoCheckRecord({contents,data,key});
        this.setState({checkStatus: "loading"},()=>{
            this.time = Date.now();
            this.checkByRequest({body:{contents:this.formatParams({contents,encryptType}),data,encryptType,key},call:(res)=>{
                    if(res?.data instanceof Array) {
                        this.formatRes({res:res?.data,formatType,call:(result)=>{
                                let count = 0;
                                for(let i in result) {
                                    count += result[i].length
                                }
                                let time = Date.now() - this.time > 1000 ? 0 : 1000 - Date.now() + this.time;
                                setTimeout(()=>{
                                    this.setState({checkStatus: "over",count},()=>{
                                        setTimeout(()=>{
                                            if(count>0) {
                                                call&&call({code:1,data:result})
                                            } else {
                                                call&&call({code:0,data:result})
                                            }
                                        },0);
                                    });
                                },time);
                            }})
                    } else {
                        this.setState({checkStatus: "over",count:0},()=>{
                            call&&call(res)
                        });
                    }
                }})
        });
    };

    formatParams = ({contents,encryptType}) => {
        let newContents = {};
        switch (encryptType) {
            case "base64":
                for(let k in contents) {
                    newContents[k] = base64Encode(contents[k]);
                }
                break;
            default:
                newContents = contents
        }
        return newContents
    };

    /**
     * 调用敏感词检测接口，返回检测结果
     * @param {object} body 接口参数
     * @param {function} call 接口返回后的回调
     * */
    checkByRequest = ({body,call}) => {
        this.request({
            url: '/cm-sites-sys/contentCheck/check',
            method: 'post',
            contentType: 'json',
            loading: false,
            body,
            callBack: (res) => {
                call&&call({code:1,data:res})
            },
            errorCallBack: () => {
                call&&call({code:-1,msg:"检测失败"})
            },
        })
    };

    /**
     * 格式化检测结果
     * @param {array} res 检测结果
     * @param {string} formatType 格式化类型
     * @param {function} call 回调
     * */
    formatRes = ({res,formatType,call}) => {
        let newRes = {};
        if(typeof res?.[2] === "object") {
            switch (formatType) {
                case "merge":
                    newRes = this.formatResMerge(res[2]);
                    break;
                default:
                    newRes = res[2]
            }
        }
        call&&call(newRes)
    };

    formatResMerge = (data) => {
        let newData = {};
        for(let key in data) {
            let arr = [];
            let item = data[key];
            for(let i=0;i<item.length;i++) {
                let Item = item[i];
                if(Item?.check?.length) {
                    arr = [...arr,...Item.check]
                }
            }
            newData[key] = arr
        }
        return newData
    };

    /**
     * 渲染检测按钮
     * @param {string} btnType 按钮类型（默认为图标型）
     * */
    renderCheckBtn = ({btnType="icon"}) => {
        let {count} = this.state;
        let btnStatus = "";
        switch (this.state.checkStatus) {
            case "change" :
                btnStatus = "change";
                break;
            case "over" :
                if(count > 0) {
                    btnStatus = "warn";
                } else {
                    btnStatus = "normal"
                }
                break;
            case "loading" :
                btnStatus = "load";
                break;
            default :
                btnStatus = "none";
        }
        switch (btnType) {
            case "color":
                return this.renderCheckBtnColor({btnStatus,btnType});
            case "icon":
                return this.renderCheckIconBtn({btnStatus,btnType});
            default:
                return this.renderCheckIconBtn({btnStatus,btnType});
        }
    };

    iconList = {
        change: changeIcon,
        warn: warnIcon,
        normal: normalIcon,
        load: loadIcon,
        none: noneIcon,
    };

    btnColorList = {
        change: "#FCAA2F",
        warn: "#F56C6C",
        normal: "#89D069",
        load: "#89D069",
        none: "#89D069",
    };

    renderCheckBtnColor = ({btnStatus,btnType}) => {
        console.log("btnStatus",btnStatus)
        return this.btnColorList[btnStatus]
    };

    renderCheckIconBtn = ({btnStatus,btnType}) => {
        return this.iconList[btnStatus]
    };

    getCheckResult = (needs) => {
        let data = {};
        for(let i=0;i<needs.length;i++) {
            data[needs[i]] = this.state[needs[i]]
        }
        return data
    };

    setCheckStatus = (checkStatus,call) => {
        this.setState({checkStatus},()=>{call&&call()})
    };

    render() {
        return (
            <div>
                {this.loadingModal()}
            </div>
        )
    }

    loadingModal = () => {
        return (
            <Modal
                title={"敏感信息检测"}
                footer={null}
                maskClosable={false}
                width={380}
                closable={false}
                centered
                visible={this.state.checkStatus === "loading"}
                closeIcon={false}
            ><img src={loadIcon} width={50} style={{marginRight:10}} />正在进行敏感信息检测，请稍后...</Modal>
        )
    }

}